// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "chunk." + {"757": "4189d8829b2d05e6","972": "0b997ae9a18aafb6",}[chunkId] + ".js"
}